import { createFileRoute } from '@tanstack/react-router'
import ConversasSistemaPage from '@/pages/dashboard/conversas-sistema-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/conversas',
)({
  component: function ConversasSistemaRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.CONVERSATIONS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <ConversasSistemaPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
